import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './RegistrationForm.html?raw';
import on from 'dojo/on';
import FileUpload from '../../../../moreCore/UI/SimpleFileUpload/SimpleFileUpload';
import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';
import "../../../../moreCore/UI/SimpleFileUpload/SimpleFileUpload";
import checkbox from '../../../../moreCore/UI/CheckBox/CheckBox';
import "../../../../moreCore/UI/CheckBox/CheckBox";
import "../DoctorListTypes";
import { ToasterHelpers } from "../../../../more/Helpers";
class RegistrationForm extends compose(_WidgetBaseSP) {
    templateString: any = template;
    private existingWebuserID: string = null;
    editMode: boolean = true;
    parentDialog: MdsLax<InstanceType<typeof GenericDialog>> = null;
    private dlg: MdsLax<InstanceType<typeof GenericDialog>> = null;
    removeApprobation: boolean = false;
    approbationExisting: boolean = false;

    private existingData: DoctorList.DoctorData = null;

    markDeletionChecked: boolean = false;
    useOwnSave: boolean = false;

    private Personal: HTMLDivElement;
    private messageOverlay: HTMLElement;
    private inputUsername: HTMLInputElement;
    private inputPassword: HTMLInputElement;
    private inputConfirmPassword: HTMLInputElement;
    private inputBirthdate: HTMLInputElement;
    private inputMail: HTMLInputElement;
    private inputSalutation: HTMLSelectElement;
    private inputPrename: HTMLInputElement;
    private inputLastname: HTMLInputElement;
    private inputAddress: HTMLInputElement;
    private inputTitle: HTMLInputElement;
    private inputPlz: HTMLInputElement;
    private inputCity: HTMLInputElement;
    private inputPhone: HTMLInputElement;
    private inputLandline: HTMLInputElement;
    private inputBan: HTMLInputElement;
    private inputRemarks: HTMLInputElement;
    private absentCount: HTMLInputElement;
    private cbMonthlyMail: MdsLax<InstanceType<typeof checkbox>>;

    private btnRemoveApprobationUpload: HTMLButtonElement;
    private btnDownloadApprobation: HTMLButtonElement;
    private btnSave: HTMLButtonElement;

    private downloadIcon: HTMLElement;

    private saveButtonContainer: HTMLDivElement;
    private passwordContainer: HTMLDivElement;
    private absentCountContainer: HTMLDivElement;
    private deleteMarkerButton: HTMLDivElement;
    private deleteMarkerCheck: HTMLElement;
    //deleteMarkerUnCheck: HTMLElement;

    private registerButton: HTMLButtonElement;
    //editButton: HTMLButtonElement;
    private deleteButton: HTMLButtonElement;
    private approbationExistingContainer: HTMLDivElement;
    private approbationNewContainer: HTMLDivElement;
    private approbationExistingText: HTMLDivElement;

    private approbationUpload: MdsLax<InstanceType<typeof FileUpload>>;

    callback: Function = null;

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.useStandbyManager = true;

    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        on(this.approbationUpload, "change", lang.hitch(this, this._serializeData));
        on(this.cbMonthlyMail, "change", lang.hitch(this, this._serializeData));

        this.setSaveButtonState();
    }

    useOwnSaveButton(value: boolean = true) {
        this.useOwnSave = value === true;
        this.setSaveButtonState();
    }

    private _setWindowTitleAttr(value: boolean): void {
        // naja, bei false kann ich jetzt auch nicht wahnsinnig viel machen, gell...

        document.title = this.stringFormat(this.translations["Doctorlist__RegistrationTitle"], this.translations["MainTitle"]);
    }

    private _serializeTimeout: number = null;
    private _onKeyUp_RegisterFormRoot(evt: KeyboardEvent) {
        if (this._serializeTimeout != null) {
            clearTimeout(this._serializeTimeout);
            this._serializeTimeout = null;
        }

        this._serializeTimeout = setTimeout(lang.hitch(this, this._serializeData), 400);
    }


    setData(doctorData, readOnly: boolean = true, showDelete: false | "showMarker" | "showButton", showAbsence: boolean = false): void  {
        this.UiModder.domClass.add(this.passwordContainer, "w3-hide");
        this.UiModder.domClass.add(this.registerButton, "w3-hide");
        //this.UiModder.domClass.remove(this.editButton, "w3-hide");
        if (this.parentDialog) {
            //this.parentDialog.setUserdefinedButton(this.translations["General_SaveChanges"],)
            // macht der Parentdialog direkt selber in dem Widget wo er aufgerufen wird, ok?
        }

        switch (showDelete) {
            case false:
            default:
                // nix;
                break;

            case "showButton":
                this.UiModder.domClass.remove(this.deleteButton, "w3-hide");
                break;

            case "showMarker":
                this.UiModder.domClass.remove(this.deleteMarkerButton, "w3-hide");
                break;
        }


        if (showAbsence === true) {
            this.UiModder.domClass.remove(this.absentCountContainer, "w3-hide");
        }

        this.editMode = readOnly != true;
        this.preFill(doctorData);
        this.setReadonlyStyle();
    }

    private setReadonlyStyle(): void {

        let fct = this.UiModder.domClass.add;

        if (this.editMode === true) {
            // bearbeitbar, also w3-disabled REMOVEN
            fct = this.UiModder.domClass.remove;
        }

        fct(this.domNode, "w3-disabled");

        //fct(this.inputAddress, "w3-disabled");
        //fct(this.inputBan, "w3-disabled");
        //fct(this.inputCity, "w3-disabled");
        //fct(this.inputConfirmPassword, "w3-disabled");
        //fct(this.inputLandline, "w3-disabled");
        //fct(this.inputLastname, "w3-disabled");
        //fct(this.inputMail, "w3-disabled");
        //fct(this.inputPassword, "w3-disabled");
        //fct(this.inputPhone, "w3-disabled");
        //fct(this.inputPlz, "w3-disabled");
        //fct(this.inputPrename, "w3-disabled");
        //fct(this.inputRemarks, "w3-disabled");
        //fct(this.inputSalutation, "w3-disabled");
        //fct(this.inputTitle, "w3-disabled");
        //fct(this.inputUsername, "w3-disabled");
        //fct(this.approbationNewContainer, "w3-disabled");
        //fct(this.btnRemoveApprobationUpload, "w3-disabled");

        fct(this.deleteButton, "w3-disabled");

        if (this.parentDialog != null && !this.editMode) {
            this.parentDialog.setUserdefinedButton(null, null, null);
        }

    }

    preFill(data: DoctorList.DoctorData): void  {
        //console.debug("registrationform preFill", data);

        this.existingData = data;

        this.existingWebuserID = data.WebUserId;

        this.inputBirthdate.value = data.birthdate;
        this.inputUsername.value = data.username;
        this.inputMail.value = data.email;
        this.inputSalutation.value = data.salutation;
        this.inputTitle.value = data.title;
        this.inputPrename.value = data.first_name;
        this.inputLastname.value = data.last_name;
        this.inputAddress.value = data.address;
        this.inputPlz.value = data.postal_code;
        this.inputCity.value = data.city;
        this.inputPhone.value = data.phone_mobile;
        this.inputLandline.value = data.phone_landline;
        this.inputBan.value = data.ban;
        this.inputRemarks.value = data.note;
        this.cbMonthlyMail.setValue(data.monthlyInfomail === true, true);

        /*if (data.is_marked_for_deleting) {
            setMarkedForDeletion
        }*/
        this.setMarkedForDeletion(data.is_marked_for_deleting);

        this.setExistingApprobation(<string>data.approbation);
        this._setDownloadButtonStyle();

        this._serializeData(true);

        this.UiModder.domAttr.set(this.absentCount, "innerHTML", data.absence_count);
    }

    setExistingApprobation(filename:string): void  {
        if (filename != "" && typeof (filename) != "undefined") {
            this.UiModder.domClass.add(this.approbationNewContainer, "w3-hide");
            this.UiModder.domClass.remove(this.approbationExistingContainer, "w3-hide");
            this.UiModder.domAttr.set(this.approbationExistingText, "innerHTML", filename);
            this.approbationExisting = true;
        }
        else {
            this.UiModder.domClass.remove(this.approbationNewContainer, "w3-hide");
            this.UiModder.domClass.add(this.approbationExistingContainer, "w3-hide");
            this.approbationExisting = false;
        }

    }

    private _onClick_RemoveApprobation(): void {
        this.setExistingApprobation("");
        this._setDownloadButtonStyle();
        this.removeApprobation = true;
        this._serializeData();
    }

    private _onClick_DownloadApprobation(evt: MouseEvent): void {
        if (this.existingWebuserID == this.getCurrentUserId() || this.hasUserRole("DOC-ADMIN")) {
            evt.stopPropagation();
            let downloadWindow = window.open(window.appRoot + this.stringFormat("Doctorlist/DownloadApprobation?targetUserId={0}&filename={1}",
                this.existingWebuserID,
                this.existingData.approbation)
            );

            //downloadWindow.close();
        }
        else {
            // nicht berechtigt!
        }
    }

    private _setDownloadButtonStyle(): void {
        this.UiModder.domClass.remove(this.btnDownloadApprobation, "mds-hover-dark");
        this.UiModder.domClass.add(this.downloadIcon, "w3-hide");

        let bShow: boolean = false;

        if (this.approbationExisting && this.removeApprobation != true ) {
            if (this.hasUserRole("DOC-ADMIN") ||
                this.existingWebuserID == this.getCurrentUserId()) {
                bShow = true;
            }
        }

        if (bShow) {
            this.UiModder.domClass.add(this.btnDownloadApprobation, "mds-hover-dark");
            this.UiModder.domClass.remove(this.downloadIcon, "w3-hide");
        }
    }

    private _registerValues: DoctorList.DoctorData = null;

    private _serializeData(resetDirty?: boolean): void{
        // bei vorhandener webuserID:
        // die approb kann bereits vorhanden gewesen sein
        // sie kann danach entfernt worden sein (removeApprobation = true)
        // sie kann nach dem Entfernen wieder neu hinzugefügt worden sein

        let approb: any = this.approbationUpload.getUploadData();
        if (this.removeApprobation === true && approb == null) {
            approb = "remove";
        }
        this._registerValues = {
            "WebUserId": this.existingWebuserID,
            "username": this.inputUsername.value,
            "email": this.inputMail.value,
            "password": this.inputPassword.value,
            "confirmPassword": this.inputConfirmPassword.value,
            "salutation": this.inputSalutation.value,
            "title": this.inputTitle.value,
            "first_name": this.inputPrename.value,
            "last_name": this.inputLastname.value,
            "birthdate": this.inputBirthdate.value,
            "address": this.inputAddress.value,
            "postal_code": this.inputPlz.value,
            "city": this.inputCity.value,
            "phone_mobile": this.inputPhone.value,
            "phone_landline": this.inputLandline.value,
            "ban": this.inputBan.value,
            "note": this.inputRemarks.value,
            "approbation": approb,
            "absence_count": 0,
            "is_marked_for_deleting": this.markDeletionChecked,
            "monthlyInfomail": this.cbMonthlyMail.getValue()
        };

        if (resetDirty === true) {
            this._registerValuesPrevious = JSON.stringify(this._registerValues);
        }

        this._checkDirty();
    }

    private _checkDirty(): void {

        if (this.existingWebuserID == null) {
            this._isDirty = true;
        } else {
            if (JSON.stringify(this._registerValues) != this._registerValuesPrevious) {
                this._isDirty = true;
            } else {
                this._isDirty = false;
            }
        }

        //console.debug("registrationForm isDirty?", this._isDirty, JSON.stringify(this._registerValues), this._registerValuesPrevious);

        this.emit("dirty", this._isDirty);

        this.setSaveButtonState();
    }

    private _registerValuesPrevious: string = null;
    private _isDirty: boolean = false;

    private _onClick_RegisterDoctor(evt: MouseEvent): boolean  {
        if (this.existingWebuserID != null) return;
        this._serializeData();
        let myFormValues = this._registerValues;

        if (!this.checkMandatoryFields()) {
            //alert("Bitte alle Pflichtfelder ausfüllen!");
            //alert(this.translations["Doctorlist__Registration_MissingMandatory"].replace("<br/>", "\r\n"));
            this.showMessage(this.translations["Doctorlist__Registration_MissingMandatory"],
                this.stringFormat(this.translations["Doctorlist__RegistrationTitle"], this.translations["MainTitle"])
            );
            return false;
        }
        else if (this.inputPassword.value !== this.inputConfirmPassword.value) {
            //alert("Passwörter stimmen nicht überein");
            //alert(this.translations["Doctorlist__Registration_PasswordsDontMatch"].replace("<br/>", "\r\n"));
            this.showMessage(this.translations["Doctorlist__Registration_PasswordsDontMatch"],
                this.stringFormat(this.translations["Doctorlist__RegistrationTitle"], this.translations["MainTitle"])
            );
            return false;
        }
        else {
            let registerFinalHitched = lang.hitch(this, this._saveRegistration, myFormValues);

            if ((myFormValues.postal_code != null && myFormValues.postal_code != "") || (myFormValues.city != null && myFormValues.city != "")) {
                this._checkPLZ(myFormValues, registerFinalHitched)
            }
            else {
                this._saveRegistration(myFormValues);
            }
        }

    }

    private _saveRegistration(values: DoctorList.DoctorData): void  {

        if (this.editMode != true) return;

        let requestUrl = window.appRoot + "Doctorlist/RegisterDoctor";

        this.StandbyStart();

        this.UiModder.domClass.add(this.registerButton, "w3-disabled");

        this.RequestManager.post(requestUrl,
            {
                "data": JSON.stringify(values)
            },
            lang.hitch(this, this._onRegisterResponse),
            lang.hitch(this, this._onRegisterError),
            false // sync
        );
    }

    _onRegisterError(Error: any): void {
        alert("registration failed:\r\n" + Error.Message);

        console.error("registration failed", Error.Message);

        this.StandbyStop();

        this.UiModder.domClass.remove(this.registerButton, "w3-disabled");
    }

    _onRegisterResponse(response: any): void {
        this.StandbyStop();

        let dlg = new GenericDialog();
        dlg._setContentAttr(this.translations["Doctorlist__Registration_SuccessMessage"]);

        dlg._setCloseBtnAttr(true);
        dlg._setOkBtnAttr(false);
        dlg._setCancelBtnAttr(false);

        dlg.show();

        this.UiModder.domClass.add(this.domNode, "registrationSaved");
        this.UiModder.domClass.remove(this.messageOverlay, "w3-hide hide hidden");

        //alert(this.translations["Doctorlist__Registration_SuccessMessage"].replace("<br/>", "\r\n"));

        if (this.parentDialog) {
            this.parentDialog.close();
        }
    }

    private _checkPLZ(values: DoctorList.DoctorData, callback: Function) {
        let requestUrl = window.appRoot + "doctorlist/CheckPLZ";

        // ACHTUNG: das darf keine normale Callfunction-API sein, weil wir hier ohne Session unterwegs sind!
        this.StandbyStart();
        this.RequestManager.post(requestUrl,
            {
                "PLZ": values.postal_code,
                "City": values.city
            },
            lang.hitch(this, this._onCheckPlzCallback, callback),
            lang.hitch(this, this._onCheckPlzError),
            false
        );
    }

    private _onCheckPlzCallback(callback: Function, response: any) {
        let result = false;


        if (typeof (response) == "string") {

            if (response === "true") {
                result = true;
            } else if (response === "false") {
                result = false;
            }
            else {
                try {
                    response = JSON.parse(response);
                } catch (ex) {
                    console.warn("_onCheckPlzCallback: invalid response", response, ex);
                }
            }
        }

        if (typeof (response) == "object") {
            if (typeof (response.valid) == "boolean") {
                result = response.valid;
            }
        }
        //var resultJson = JSON.parse(result);

        this.StandbyStop();

        if (result === true) {
            if (typeof (callback) == "function") {
                callback();
            }

        }

        else {
            //alert("Ungültiges PLZ/Stadt");
            //alert(this.translations["Doctorlist__Registration_InvalidPostal"].replace("<br/>", "\r\n"));
            this.showMessage(this.translate("Doctorlist__Registration_InvalidPostal"));
        }
    }

    _onCheckPlzError(error: any) {
        this.StandbyStop();
        alert("Error checking PLZ - please try again\r\n" + error.Message);
    }

    _onClick_SaveEdit(evt: MouseEvent) {
        if (this.useOwnSave != true) {
            return;
        }

        if (this._isDirty != true) {
            return;
        }

        this.saveEdit();
    }

    saveEdit(): void {
        if (this.editMode != true) return;
        this._serializeData();
        var sendVal = this._registerValues;

        let doctorID = this.existingWebuserID;

        if (doctorID == "" || doctorID == null) {
            return;
        }

        if (!this.checkMandatoryFields()) {
            //alert("Bitte alle Pflichtfelder ausfüllen!");
            //alert(this.translations["Doctorlist__Registration_MissingMandatory"].replace("<br/>", "\r\n"));
            this.showMessage(this.translations["Doctorlist__Registration_MissingMandatory"]);
            return;
        }
        else {
            //console.log(sendVal.postal_code, sendVal.city);
            //console.log((sendVal.postal_code != null && sendVal.plz != "") || (sendVal.city != null && sendVal.city != ""));

            if ((sendVal.postal_code != null && sendVal.postal_code != "") || (sendVal.city != null && sendVal.city != "")) {
                this._checkPLZ(sendVal, lang.hitch(this, this._saveEdit, sendVal));
            }
            else {
                this._saveEdit(sendVal);
            }
        }
    }

    private _saveEdit(values: DoctorList.DoctorData): void {
        if (this.editMode != true) return;
        let requestUrl = window.appRoot + "Doctorlist/EditDoctor";

        let approfileObj = this.approbationUpload.getUploadData();
        let filename = "";

        let approData;
        if (approfileObj != null) {
            if (approfileObj.files) {
                if (approfileObj.files.length == 1) {
                    filename = approfileObj.files[0].FileName;
                }
            }
        }
        else if (this.removeApprobation) {
            approData = "remove";
            values.approbation = approData;
        }
        else {
            approData = "null";
        }



        //console.log(approData);

        this.StandbyStart();

        //console.log(values);
        this.RequestManager.post(
            requestUrl,
            {
                'data': JSON.stringify(values),
            },
            lang.hitch(this, this._onSaveEditResponse, filename),
            lang.hitch(this, this._onSaveEditError),
            false // sync
        );
    }

    _onSaveEditResponse(filename: string, response: any) {
        this.StandbyStop();
        this._serializeData(true);

        this.showToast(this.translate("General_SavingSuccessful"), ToasterHelpers.ToasterIcons.confirmCheck);

        if (filename) {
            this.setExistingApprobation(filename);
        }

        if (typeof (this.callback) == "function") {
            this.callback();
        }
        if (this.parentDialog != null) {
            this.parentDialog.close();
        }
    }

    _onSaveEditError(error) {
        this.StandbyStop();

        this.showMessage("Saving edit failed:\r\n" + error.Message);
    }

    _onClick_Deactivate(evt: MouseEvent): void {

        if (this.existingWebuserID == null) return;

        evt.stopPropagation();

        let dlg = new GenericDialog();

        dlg._setHeaderAttr(this.translations["Doctorlist__RegistrationForm_Dlg_DeactivateHeader"]);
        dlg._setContentAttr(this.translations["Doctorlist__RegistrationForm_Dlg_DeactivateMessage"]);
        dlg._setNoBtnAttr(false);
        dlg._setCancelBtnAttr(true);

        let fct = lang.hitch(this, this._deactivateDoctor, this.existingWebuserID)

        dlg.setUserdefinedButton(this.translations["Doctorlist__RegistrationForm_BtnDeactivate"], "fas fa-trash-alt warningTXT", fct);

        dlg.show();
    }

    private _deactivateDoctor(selectedID: string): void {
        let requestUrl = window.appRoot + "doctorlist/DeactivateDoctor";

        this.StandbyStart();

        let data = { "webuserID": this.existingWebuserID };

        //console.log(doctor);
        this.RequestManager.post(
            requestUrl,
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onDeactivateDoctorResponse),
            lang.hitch(this, this._onDeactivateDoctorError),
            false // sync
        );
    }

    private _onDeactivateDoctorResponse(response) {
        this.StandbyStop();
        if (typeof (this.callback) == "function") {
            this.callback();
        }

        if (this.parentDialog != null) {
            this.parentDialog.close();
        }
    }

    private _onDeactivateDoctorError(error) {
        this.StandbyStop();
        this.showMessage("Error deactivating:\r\n" + error.Message);
    }

    private checkMandatoryFields(): boolean {

        //console.debug("checkFilledFields", this.approbationUpload._fileToUpload, this.approbationExisting);
        if (
            this.inputUsername.value === "" ||
            this.inputMail.value === "" ||
            this.inputSalutation.value === "" ||
            this.inputPrename.value === "" ||
            this.inputLastname.value === "" ||
            this.inputBirthdate.value === "" ||
            //this.ban.value === "" ||
            this.inputPhone.value === "" ||
            this.inputRemarks.value === "" ||
            (!this.approbationUpload.getUploadData() && this.approbationExisting != true) ||

            typeof (this.inputUsername.value) == "undefined" ||
            typeof (this.inputMail.value) == "undefined" ||
            typeof (this.inputBirthdate.value) == "undefined" ||
            typeof (this.inputSalutation.value) == "undefined" ||
            typeof (this.inputPrename.value) == "undefined" ||
            typeof (this.inputLastname.value) == "undefined" ||
            // typeof (this.ban.value) == "undefined" ||
            typeof (this.inputPhone.value) == "undefined" ||
            typeof (this.inputRemarks.value) == "undefined"
        ) {
            return false;
        }
        else {
            return true;
        }
    }

    private _onClick_MarkDeletion(evt: MouseEvent): void {
        var newVal = !this.markDeletionChecked;

        if (newVal) {
            this.showMarkDeleteConfirmDialog();
        }
        else {
            this.setMarkedForDeletion(false);
        }
    }

    setMarkedForDeletion(newVal: boolean) : void {
        if (newVal) {
            this.markDeletionChecked = true;
            this.UiModder.domClass.add(this.deleteMarkerButton, "deleting")

            //this.UiModder.domStyle.set(this.deleteMarkerButton, "background-color", "#a50000")
            //this.UiModder.domClass.remove(this.deleteMarkerCheck, "w3-hide");
            this.UiModder.domStyle.set(this.deleteMarkerCheck, "visibility", "visible");
            //this.UiModder.domClass.add(this.deleteMarkerUnCheck, "w3-hide");
        }
        else {
            this.markDeletionChecked = false;
            this.UiModder.domClass.remove(this.deleteMarkerButton, "deleting")

            //this.UiModder.domStyle.set(this.deleteMarkerButton, "background-color", "#565656")
            this.UiModder.domStyle.set(this.deleteMarkerCheck, "visibility", "hidden");
            //this.UiModder.domClass.add(this.deleteMarkerCheck, "w3-hide");
            //this.UiModder.domClass.remove(this.deleteMarkerUnCheck, "w3-hide");
        }

        this._serializeData();
    }

    private showMarkDeleteConfirmDialog(): void  {
        var dialog = new GenericDialog();

        dialog._setHeaderAttr(this.translations["Doctorlist__User_MarkDeleteConfirmDlg_Header"]);
        dialog._setContentAttr(this.translations["Doctorlist__User_MarkDeleteConfirmDlg_Content"]);
        dialog._setSubTitleAttr(this.translations["Doctorlist__User_MarkDeleteConfirmDlg_Subtitle"], true);
        dialog._setCallbackAttr(lang.hitch(this, "markDeleteConfirmCallback"));

        dialog._setOkBtnAttr(true);
        dialog._setCancelBtnAttr(true);

        dialog.show();
    }

    private markDeleteConfirmCallback(dlgResult: number): void  {
        if (dlgResult <= 0) {
            return;
        }

        this.setMarkedForDeletion(true);
        }

    private setSaveButtonState(): void {
        if (this.useOwnSave != true || this.editMode != true) {
            this.UiModder.domClass.add(this.saveButtonContainer, "w3-hide");
        } else {
            this.UiModder.domClass.remove(this.saveButtonContainer, "w3-hide");

            if (this._isDirty) {
                this.UiModder.domClass.remove(this.btnSave, "w3-disabled");
            } else {
                this.UiModder.domClass.add(this.btnSave, "w3-disabled");
            }
        }
    }

    private showMessage(message: string | false,
        header: string = this.stringFormat(this.translations["Doctorlist__MainTitle"],
            this.translations["MainTitle"])) {
        if (message === false) {


            return;
        }

        if (this.dlg != null) {
            if (this.dlg._destroyed != true) {
                this.dlg.close();
            }
        }

        this.dlg = new GenericDialog();

        let dlg = this.dlg;

        dlg._setHeaderAttr(header);
        dlg._setContentAttr(message);
        dlg._setOkBtnAttr(true);
        dlg._setTopCloseBtnAttr(true);
        dlg._setCloseBtnAttr(false);
        dlg._setCancelBtnAttr(false);

        dlg.show();

    }
}

export default mdsWidget(RegistrationForm);
